<template>
  <div class="search">
    <ui-button @click="open()" icon="search" text>
      Rechercher
    </ui-button>
    <Modal ref="modalSearch">
      <form v-on:submit.prevent="search()">
        <input type="search" v-model="searchTerm" />
        <input type="submit" value="Rechercher" />
      </form>
    </Modal>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import Modal from "@/components/ui/Modal.vue";
export default {
  name: "Search",
  components: { Modal, UiButton },
  data() {
    return {
      searchTerm: ""
    };
  },
  methods: {
    open() {
      this.$refs.modalSearch.open();
    },
    search() {
      this.$router.push({
        name: "search",
        params: { slug: this.searchTerm }
      });
      this.$refs.modalSearch.close();
    }
  }
};
</script>
<style lang="scss">
.search {
  &__open {
    background: transparent;
    border: 0;
    padding: 0;
  }
}
</style>
